import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'org'

const api = new ApiCore({
	index: true,
    getOrg: true,
	findOne: false,
	create: false,
	update: false,
	remove: false,
	url: url,
})


api.getOrgData = (id) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${id}`)
		.then(handleResponse)
		.catch(handleError);
}

api.downloadFile = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${params.orgID}/files/download/${params.file}`,{
			responseType: 'arraybuffer'
		})
		.then(handleResponse)
		.catch(handleError);
}

api.downloadFileUrl = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${params.orgID}/files/download/url/${params.file}`)
		.then(handleResponse)
		.catch(handleError);
}

export default api
